import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IDiscountCoupon, IDiscountCouponRequest } from '../interfaces/discount-coupon.interface';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DiscountCouponService {
    http = inject(HttpClient);
    baseUrl = environment.apiUrl;

    getAll(): Observable<IDiscountCoupon[]> {
        return this.http.get<IDiscountCoupon[]>(`${this.baseUrl}/discount-coupon`);
    }

    getById(id: number): Observable<IDiscountCoupon> {
        return this.http.get<IDiscountCoupon>(`${this.baseUrl}/discount-coupon/${id}`);
    }

    create(request: IDiscountCouponRequest): Observable<IDiscountCoupon> {
        return this.http.post<IDiscountCoupon>(`${this.baseUrl}/discount-coupon`, request);
    }

    update(id: number, request: IDiscountCouponRequest): Observable<IDiscountCoupon> {
        return this.http.put<IDiscountCoupon>(`${this.baseUrl}/discount-coupon/${id}`, request);
    }
}
